import styled from "styled-components";
import { Textfield } from "@similarweb/ui-components";
import { Button, IconButton } from "@similarweb/ui-components";
import { FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const Header = styled(FlexRow)`
    align-items: center;
    margin-bottom: 32px;
`;

export const Title = styled.h1`
    margin: 0;
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
`;

export const Emoji = styled.img`
    margin-left: 5px;
    width: 22px;
    height: 24px;
`;

export const Description = styled.p`
    margin-bottom: 0;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
`;

export const LeanMoreLink = styled.a`
    ${setFontVariant("body1", colorsPalettes.blue[400])};
`;

export const FieldsContainer = styled(FlexColumn)`
    row-gap: 16px;
    width: 100%;
    max-height: 328px;
    margin: 16px 0;
    padding-right: 7px;
    overflow: hidden auto;
`;

export const EmailField = styled(Textfield)`
    margin: 0;
`;

export const AddButton = styled(IconButton)`
    ${setFontVariant("button", colorsPalettes.blue[400])};
`;

export const ErrorPrompt = styled(FlexRow)`
    align-items: center;
    width: 100%;
    height: 52px;
    padding: 16px;
    margin-top: 24px;
    border-radius: 3px;
    border: 1px solid ${colorsPalettes.red[300]};
    background-color: ${colorsPalettes.red[100]};
    box-sizing: border-box;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;

export const Footer = styled(FlexRow)`
    flex-direction: row-reverse;
    justify-content: space-between;
    width: calc(100% + 16px);
    margin: 24px 0 -4px -8px;
`;

export const CopyButton = styled(IconButton)`
    ${setFontVariant("button", colorsPalettes.carbon[500])};

    .SWReactIcons {
        filter: brightness(0);
    }
`;

export const ButtonsContainer = styled(FlexRow)`
    gap: 8px;
`;

export const CancelButton = styled(Button)`
    ${setFontVariant("button", colorsPalettes.blue[400])};
`;

export const SendButton = styled(Button)`
    ${setFontVariant("button", colorsPalettes.carbon[0])};
`;
